// Persistent component registry — UI that lives OUTSIDE the Barba
// container .site-wrapper (body-level overlays: cursor, modals, loader…)
// and survives page transitions. The header is INSIDE the container and
// swaps with the page — its behavior belongs in a block, not here.
//
// Scans the document once on boot for [data-component="name"] and
// lazy-loads resources/js/components/<name>.js — same contract as blocks
// (extend core/Block), but exit()/destroy() never run on navigation.
// Subscribe to 'page:leave' / 'page:enter' on the bus to react to
// transitions.
const active = [];

export async function mountComponents(root = document) {
	const nodes = [...root.querySelectorAll('[data-component]')];

	await Promise.all(
		nodes.map(async (el) => {
			const name = el.dataset.component;

			let module;
			try {
				module = await import(
					/* webpackChunkName: "component-[request]" */
					/* webpackExclude: /_template/ */
					`../components/${name}`
				);
			} catch (error) {
				// eslint-disable-next-line no-console
				console.warn(`[components] no module for data-component="${name}"`, error);
				return;
			}

			const component = new module.default(el);
			component.inViewport = true;
			active.push(component);
			component.enter();
			component.scroll();
		})
	);
}

// Find a mounted component by name (first match).
export function getComponent(name) {
	return active.find((c) => c.el.dataset.component === name) || null;
}
